import { SidebarInset } from "@/shared/components/ui/sidebar";
import { ComponentProps, ReactNode } from "react";
import { cn } from "@/shared/lib/utils";

export function CustomerPageMain({ children }: { children: ReactNode }) {
  return <SidebarInset className="pt-16">{children}</SidebarInset>;
}

export function CustomerPageMainHeader({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <header
      className={cn(
        // The w-full will extend the header over the screen. To compensate,
        // the pr is dynamically calculated based on the sidebar width.
        "peer/header bg-background fixed top-16 z-40 flex h-16 w-full shrink-0 items-center gap-2 border-b px-4 pr-[calc(var(--sidebar-width)+(--spacing(4)))] transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 group-has-data-[collapsible=icon]/sidebar-wrapper:pr-[calc(var(--sidebar-width-icon)+(--spacing(4)))]",
        className,
      )}
    >
      {children}
    </header>
  );
}

export function CustomerPageMainContent({
  children,
  className,
  ...props
}: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "flex flex-1 flex-col pt-3 pr-4 pb-4 pl-5 group-has-data-[collapsible=icon]/sidebar-wrapper:mt-12 peer-[*]/header:mt-16",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
